<template>
  <div class="level__title-wrapper">
    <component
      v-if="labType"
      :is="labIcon"
      :class="[
        'level__lab-icon',
        labType === 'els' && 'level__lab-icon--els',
        isLabFinished && 'level__lab-icon--finished',
      ]"
    />
    <p class="level__title">
      {{ title }}
      <label v-if="isLabFinished" class="level__title--label">
        <span class="material-icons level__title--label-icon">check</span>
        Finished
      </label>
    </p>
  </div>
</template>

<script>
import GitHubIcon from '@/assets/icons/course/lab/github-icon.svg'
import AzureIcon from '@/assets/icons/course/lab/azure-icon.svg'
import ELSLabIcon from '@/assets/icons/course/lab/els-lab-icon.svg'
import CONSTANTS from '@/constants'

export default {
  name: 'LevelTitle',
  components: {
    GitHubIcon: { ...GitHubIcon, name: 'GitHubIcon' },
    AzureIcon: { ...AzureIcon, name: 'AzureIcon' },
    ELSLabIcon: { ...ELSLabIcon, name: 'ELSLabIcon' },
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    labType: {
      type: String,
      required: false,
    },
    labStatus: {
      type: String,
      required: false,
    },
  },
  computed: {
    labIcon() {
      if (this.labType === 'github') {
        return GitHubIcon
      }
      if (this.labType === 'azure') {
        return AzureIcon
      }
      return ELSLabIcon
    },
    isLabFinished() {
      return (
        this.labStatus &&
        this.labStatus === CONSTANTS.CONTENT_USER_STATUS.FINISHED
      )
    },
  },
}
</script>
